var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 11.3333L7.99967 14M7.99967 14L10.6663 11.3333M7.99967 14V8M13.333 11.1619C14.1473 10.4894 14.6663 9.47196 14.6663 8.33333C14.6663 6.30829 13.0247 4.66667 10.9997 4.66667C10.854 4.66667 10.7177 4.59066 10.6438 4.46516C9.77438 2.98989 8.1693 2 6.33301 2C3.57158 2 1.33301 4.23858 1.33301 7C1.33301 8.3774 1.88997 9.62472 2.79097 10.529",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.234036a14c56c66e509d1ee65ec68be0.svg";
export { ForwardRef as ReactComponent };